import MuiListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './ListItem.module.scss';

interface Props {
  text: string;
  url: string;
}

const ListItem: FC<Props> = ({ text, url }) => (
  <Link to={url}>
    <MuiListItem disablePadding className={styles.listItem}>
      <ListItemButton>
        <ListItemText primary={text} />
      </ListItemButton>
    </MuiListItem>
  </Link>
);

export default ListItem;
